import { ShopCartItem, ShopCartType } from 'types';

const typeOrder = Object.values(ShopCartType);

export const sortShopList = (cartList: ShopCartItem[] = []) =>
  [...cartList]
    .filter((item) => !item?.is_promo)
    .sort((a: ShopCartItem, b: ShopCartItem) => {
      const typeA = a?.item_type;
      const typeB = b?.item_type;

      if (typeA === typeB) {
        return a > b ? 1 : -1;
      }
      return typeOrder.indexOf(typeA) > typeOrder.indexOf(typeB) ? 1 : -1;
    });
